import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'

type generateLinkArrayOptions = {
  searchCity: string
  staySearchHref: string
  flySearchHref: string
  driveSearchHref: string
}

export default function generateLinkArray({
  searchCity,
  staySearchHref,
  flySearchHref,
  driveSearchHref
}: generateLinkArrayOptions) {
  return [
    {
      gaAction: 'Popular_Hotels_Destinations',
      gaCategory: ANALYTICS_CATEGORY_HOME,
      gaLabel: `Hotels Link | ${searchCity}`,
      href: `${staySearchHref}`,
      linkTitle: 'Hotels',
      target: '_blank'
    },
    {
      gaAction: 'Popular_Cars_Destinations',
      gaCategory: ANALYTICS_CATEGORY_HOME,
      gaLabel: `Cars Link | ${searchCity}`,
      href: `${driveSearchHref}`,
      linkTitle: 'Cars',
      target: '_blank'
    },
    {
      gaAction: 'Popular_Flights_Destinations',
      gaCategory: ANALYTICS_CATEGORY_HOME,
      gaLabel: `Flights Link | ${searchCity}`,
      href: `${flySearchHref}`,
      linkTitle: 'Flights',
      target: '_blank'
    }
  ]
}
